import React from "react";

/* -------------------------------------------------------------------------
 * SettlementIcons — small inline SVGs used by the settlement dashboard cards.
 * Kept dependency-free (no lucide-react assumption) so these components can
 * be dropped into the project as-is.
 * ---------------------------------------------------------------------- */

export const InfoIcon = (props) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="12" cy="7.7" r="1" fill="currentColor" />
  </svg>
);

export const SpendIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M2.5 9.5h19" stroke="currentColor" strokeWidth="1.7" />
    <path d="M6 14.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const GiftIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="3" y="9.5" width="18" height="10.5" rx="1.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3 9.5h18" stroke="currentColor" strokeWidth="1.7" />
    <path d="M12 9.5V20" stroke="currentColor" strokeWidth="1.7" />
    <path d="M12 9.5c0-2.4-1.8-4.3-3.8-4.3S5 6.2 5.6 8c.5 1.4 2.6 1.5 6.4 1.5Z" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 9.5c0-2.4 1.8-4.3 3.8-4.3S18.9 6.2 18.4 8c-.5 1.4-2.6 1.5-6.4 1.5Z" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const PercentIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M18 6 6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="7.5" cy="7.5" r="2.3" stroke="currentColor" strokeWidth="1.7" />
    <circle cx="16.5" cy="16.5" r="2.3" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

export const DollarIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M12 3v18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M16.5 7.2c0-1.8-2-3.2-4.5-3.2s-4.5 1.3-4.5 3.1c0 4.1 9 2 9 6 0 1.9-2 3.4-4.5 3.4S7.5 15 7.5 13.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const ChartIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4 20V10M11 20V4M18 20v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
    <path d="m21 21-3.6-3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const FilterIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4 6h16M7 12h10M10.5 18h3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const DownloadIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M12 4v11m0 0-4-4m4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 18v1.5A1.5 1.5 0 0 0 5.5 21h13a1.5 1.5 0 0 0 1.5-1.5V18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const ClockIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
    <path d="M12 7v5.5l3.5 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const RepeatIcon = (props) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4 12a8 8 0 0 1 13.7-5.7L20 8M20 4v4h-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 12a8 8 0 0 1-13.7 5.7L4 16M4 20v-4h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BankIcon = (props) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M3 10 12 4l9 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 10.5V19M9 10.5V19M15 10.5V19M19.5 10.5V19" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M3 19h18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const ActivityDotIcon = (props) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M12 3v3.5M12 17.5V21M3 12h3.5M17.5 12H21" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DocumentIcon = (props) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M6 3h8l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="1.6" />
    <path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const KebabIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="5.5" r="1.4" fill="currentColor" />
    <circle cx="12" cy="12" r="1.4" fill="currentColor" />
    <circle cx="12" cy="18.5" r="1.4" fill="currentColor" />
  </svg>
);
